
import { makeAutoObservable } from "mobx";
import { DEFAULT_MENU } from 'constants';

class CommonStore {
  menuList = [];
  menuNmPath = [];
  defaultMenu = DEFAULT_MENU;

  constructor() {
    makeAutoObservable(this);
  }

  setMenuList = (menuList) => {
    return this.menuList = menuList;
  };

  setMenuNmPath = (menuNmPath) => {
    return this.menuNmPath = menuNmPath;
  }

  setDefaultMenu = (defaultMenu) => {
    return this.defaultMenu = (defaultMenu || DEFAULT_MENU);
  }
  
}

export default CommonStore;